enum NextSelection {
  DoorCount = 'DoorCount',
  ModelVersion = 'ModelVersion',
  ParentModel = 'ParentModel',
  Trim = 'Trim',
  TruckBodyStyle = 'TruckBodyStyle',
  Year = 'Year'
}

export default NextSelection;
